module.exports = __webpack_public_path__ + "assets/img/add_user_thumb.d4eccffd.png";